export const CONFIG = {
  // React Router basename for preview subpath deploys (mirrors vite.config `base`).
  // Vite's BASE_URL is "/" on staging/prod and "/<branch>/" on preview channels;
  // React Router v5 wants a leading slash but no trailing one, so "/" collapses
  // to "" (no base). Without this, routes won't match under the preview subpath.
  BASE_PATH: import.meta.env.BASE_URL.replace(/\/$/, ""),
  API_SERVER: import.meta.env.VITE_API_SERVER,
  API_LOGIN: import.meta.env.VITE_LOGOUT_URL,
  INBOX_URL: "https://inbox.sudonum.com",
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  // Set by prod.yml ("production") and staging.yml ("staging"). Falls back to
  // "development" rather than the SDK's own default, "production", so a build
  // without the variable can't pass itself off as production in Sentry.
  SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT || "development",
  // The deployed commit SHA, also set by prod.yml and staging.yml.
  SENTRY_RELEASE: import.meta.env.VITE_SENTRY_RELEASE || undefined,
  WHATSAPP_RPLY_LINK: "https://rply.link",
  // Meta Embedded Signup config ID (WhatsApp onboarding). Both the classic and
  // the coexistence ("Connect your WhatsApp Business app") flows use the SAME
  // config — coexistence is enabled on this config in the Meta dashboard and is
  // triggered at launch time via extras.featureType (see AccountSetup). Falls
  // back to the long-standing config so existing deployments keep working.
  WA_ES_CONFIG_ID: import.meta.env.VITE_WA_ES_CONFIG_ID || "723191849827879",
  fireAuth: {
    apiKey: import.meta.env.VITE_FB_API_KEY,
    authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FB_PROJECTID,
    storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET,
    functionBaseURL: import.meta.env.VITE_FB_FUNC_BASEURL,
    messagingSenderId: import.meta.env.VITE_FB_MSG_SENDER_ID,
  },
  MAX_SMS_LENGTH: 160,
};
